<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2>Выгрузка XML-отчёта по реализации товаров</h2>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-card flat tile>
          <v-card-text>
            <v-toolbar flat>
              <v-menu offset-y bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                  class="mx-3"
                  label="Выберите дату"
                  v-model="day"
                  v-on="on"
                  :disabled="inAction"
                  style="max-width: 220px"
                  hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                :disabled="inAction" locale="ru" first-day-of-week="1"
                v-model="day" :landscape="true" :reactive="true"
                ></v-date-picker>
              </v-menu>
              <v-btn
              color="primary"
              class="mx-5"
              :disabled="inAction || !day"
              @click="makeReport()"
              >Сформировать отчёт</v-btn>
              <v-btn
                @click="saveAs()"
                :disabled="inAction"
                v-if="inAction || xml"
              >
                <template v-if="inAction">
                  Подождите... &nbsp;
                  <v-progress-circular
                  color="deep-purple accent-4"
                  :size="25" :value="progress"
                  ></v-progress-circular>
                </template>
                <template v-else>
                  <v-icon>save</v-icon>
                  <span>Сохранить XML [{{xmlfilename}}]</span>
                </template>
              </v-btn>
            </v-toolbar>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
let builder = require('xmlbuilder')
const FileSaver = require('file-saver')

function rubles (kops) {
  return (parseFloat(kops) / 100).toFixed(2)
}

export default {
  name: 'OrgXmlReport',
  data: () => ({
    day: null,
    inAction: false,
    progress: 0,
    xml: null,
    xmlfilename: null
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    orgid () {
      return this.profile ? this.profile.orgid : null
    },
  },
  methods: {
    asyncTimeout (to) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, to)
      })
    },
    async makeReport () {
      try {
        const day = this.day
        if (!day) throw new Error('Выберите дату')
        this.progress = 1
        this.inAction = true
        await this.asyncTimeout(500)
        const { menu } = await this.$store.dispatch('sioRequest', {
          topic: 'org-menu',
          pl: { day }
        })
        const totalCafes = Object.keys(menu).length
        const { report } = await this.$store.dispatch('sioRequest', {
          topic: 'org-sales-by-productid',
          pl: { day }
        })
        const { rollbacks } = await this.$store.dispatch('sioRequest', {
          topic: 'org-rollbacks',
          pl: { day }
        })
        const { saletypes } = await this.$store.dispatch('sioRequest', {
          topic: 'org-saletypes',
          pl: { day }
        })
        var root = builder.create('Заголовок')
        let done = 5
        const nodeSts = root.ele('ВидыРеализации')
        for (let st of saletypes) {
          const nodeSt = nodeSts.ele('ВидРеализации')
          nodeSt.ele('Код', null, st.saletypeid)
          nodeSt.ele('Наименование', null, st.title)
        }
        for (let cafeid of [...Object.keys(menu)]) {
          done++
          if (done % 10 === 0) {
            this.progress = Math.round(100 * parseFloat(done) / totalCafes)
          }
          const nodeCafe = root.ele('Столовая')
          console.log('Столовая', cafeid)
          nodeCafe
            .ele('Код', null, cafeid)
          nodeCafe
            .ele('Наименование', null, menu[cafeid].title)
          for (let group of menu[cafeid].groups) {
            const nodeGroup = nodeCafe
              .ele('ГруппаТовара')
            nodeGroup
              .ele('Код', null, group.groupcode)
            nodeGroup
              .ele('Наименование', null, group.title)
            for (let product of group.products) {
              const nodeProduct = nodeGroup
                .ele('Товар')
              nodeProduct
                .ele('Код', null, product.productcode)
              nodeProduct
                .ele('Наименование', null, product.title)
              nodeProduct
                .ele('ЕдИзм', null, 'порц')
              nodeProduct
                .ele('Цена', null, rubles(product.price))
              const sales = report[product.productid]
              if (sales && sales.length > 0) {
                for (let sale of sales) {
                  const nodeSale = nodeProduct
                    .ele('ВидРеализации')
                  nodeSale
                    .ele('Код', null, sale.s)
                  nodeSale
                    .ele('Количество', null, `${sale.c}`)
                  nodeSale
                    .ele('Сумма', null, rubles(product.price * parseInt(sale.c)))
                  // </ВидРеализации>
                }
              }
              // </Товар>
            }
            // </ГрупппаТовара>
          }
          const rb = rollbacks[cafeid] || { count: 0, sum: 0 }
          const nodeRb = nodeCafe
            .ele('Отмены_чеков')
          nodeRb
            .att('Кол-во', rb.count)
          nodeRb
            .att('Сумма', rubles(rb.sum))
          // список комплексов по школе
          nodeCafe.ele('КомплексноеПитание')
          // </Столовая>
          await this.asyncTimeout(100)
        }
        // </Заголовок>
        const xml = root.end({ pretty: true })
        this.xml = xml.split('<?xml version="1.0"?>').join('<?xml version="1.0" encoding="UTF-8"?>')
        this.xmlfilename = `${this.orgid}-${this.day}.xml`
      } catch (e) {
        console.log(e)
        this.$store.dispatch('snack', e)
      } finally {
        this.inAction = false
      }
    },

    saveAs () {
      const file = new File(
        [this.xml],
        this.xmlfilename,
        { type: 'text/plain;charset=utf-8' }
      )
      FileSaver.saveAs(file)
    },
  },
  watch: {
    day () {
      this.xml = null
      this.xmlfilename = null
    }
  },
}
</script>
